import { hWebCrossUpperLeft, hWebCrossUpperLeft2, hWebCrossUpperRight } from '../lace/hWebCross'
import { middleSidePartOfWeb, topSidePartOfWeb } from './parts/sideParts'

export const w32Web = (
  ctx: CanvasRenderingContext2D,
  edgeColor: string,
  laceColor: string,
  stitchColor: string,
  webColor: string,
  webColor2?: string
): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  // ウェブ縦
  ctx.fillStyle = webColor2 || webColor
  ctx.beginPath()
  ctx.moveTo(238, 241) // 左＿上
  ctx.quadraticCurveTo(257, 262, 257, 262) // 左＿下
  ctx.quadraticCurveTo(265, 243, 298, 204) // 右＿下
  ctx.quadraticCurveTo(293, 156, 293, 156) // 右＿上
  ctx.quadraticCurveTo(254, 199, 238, 241) // 左＿上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // 捕球面とウェブ横2を繋ぐ革紐
  hWebCrossUpperLeft(ctx, laceColor, 0, 0) // クロス部分の右
  hWebCrossUpperLeft(ctx, laceColor, -3, 3) // クロス部分の右
  hWebCrossUpperRight(ctx, laceColor, 0, 0) // クロス部分の右
  hWebCrossUpperRight(ctx, laceColor, -3, 3) // クロス部分の右
  hWebCrossUpperLeft2(ctx, laceColor, 0, 0) // クロス部分の左
  hWebCrossUpperLeft2(ctx, laceColor, -3, 3) // クロス部分の左
  // ウェブ横2
  middleSidePartOfWeb(ctx, webColor, stitchColor, 5, 10)

  // ヘリ革＿左
  ctx.fillStyle = edgeColor
  ctx.beginPath()
  ctx.moveTo(238, 241) // 左＿上
  ctx.quadraticCurveTo(257, 262, 257, 262) // 左＿下
  ctx.quadraticCurveTo(261, 252, 261, 252) // 右＿下
  ctx.quadraticCurveTo(242, 226, 242, 226) // 右＿上
  ctx.quadraticCurveTo(238, 241, 238, 241) // 左＿上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // ヘリ革＿右
  ctx.beginPath()
  ctx.moveTo(283, 168) // 左＿上
  ctx.quadraticCurveTo(289, 212, 289, 212) // 左＿下
  ctx.quadraticCurveTo(298, 202, 298, 202) // 右＿下
  ctx.quadraticCurveTo(293, 157, 293, 157) // 右＿上
  ctx.quadraticCurveTo(283, 168, 283, 168) // 左＿上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // ウェブ横1(先端)
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)

  // stitchここから
  ctx.lineWidth = 1.2
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  // 縦＿左
  ctx.moveTo(245, 228) // 上
  ctx.quadraticCurveTo(261, 250, 261, 250) // 下
  // 縦＿右
  ctx.moveTo(282, 170) // 上
  ctx.quadraticCurveTo(288, 213, 288, 213) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
}
